import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import Sidebar from "../../components/Sidebar";
import { useBusinessAuthContext } from "../commoncomponents/useBusinessAuthContext";
import WaiverStepLayout from "./WaiverStepLayout";
import API_URL from "../../api/API";
import WAIVER_STEP_RULES from "./WaiverStepConfig";

const BusinessSmartTemplateStep2 = () => {
  
  const { business } = useBusinessAuthContext();
  const navigate = useNavigate();
  const { waiverId } = useParams();
  const [locations, setLocations] = useState([]);
  const [selected, setSelected] = useState([]); // array of ids
  const [loading, setLoading] = useState(true);

  const [searchParams] = useSearchParams();
  const newLocationId = searchParams.get("new");

  const [blockedLocations, setBlockedLocations] = useState([]);

  const [saving, setSaving] = useState(false);

  const [waiver, setWaiver] = useState(null);
  /*const WAIVER_STATUS_RULES = {
    new_version: {
      readOnly: true,
      reason:
        "Locations cannot be updated in New Version.",
    },
    published: {
      readOnly: true,
      reason:
        "Waiver is published.",
    },
  };*/
  const stepRules = WAIVER_STEP_RULES["step2"] || {};
  const statusRule = stepRules[waiver?.waiverStatus] || {};
  const isReadOnly = statusRule.readOnly ?? false;
  const readOnlyReason = statusRule.reason ?? "";

   useEffect(() => {
    if (!business) {
      navigate("/business/login");
      return;
    }

    const headers = {
      headers: {
        Authorization: `Bearer ${business.token}`,
        "x-session-id": business.sessionId,
        "x-frontend-url": window.location.pathname,
      },
    };

    const loadData = async () => {
      try {
        setLoading(true);

        // 1️⃣ get waiver FIRST (you need serviceId from here)
        const waiverRes = await fetch(
          `${API_URL.BUSINESS_WAIVER_BY_ID}/${waiverId}`,
          headers
        );
        const waiverData = await waiverRes.json();
        if (!waiverData.success) {
          alert("Data Failure!");
          return;
        }

        setWaiver(waiverData.waiver);
        
        const isArchivedWaiver = 
          waiverData?.waiver?.isDeleted ||
          waiverData?.waiver?.waiverStatus === "archived_by_admin" ||
          waiverData?.waiver?.waiverStatus === "archived_by_new_version" ||
          waiverData?.waiver?.waiverStatus === "archived_by_location_deletion" ;

        // 2️⃣ now you have serviceId safely
        const serviceId = waiverData.waiver.serviceId;

        // 3️⃣ run remaining calls in parallel
        const [locRes, conflictRes] = await Promise.all([
          fetch(
            `${API_URL.BUSINESS_LOCATIONS}${
              isArchivedWaiver ? "?includeArchived=true" : ""
            }`,
            headers
          ),
          fetch(`${API_URL.EXISTING_LOCATIONS}/${serviceId}/${waiverId}`, headers),
        ]);

        const locData = await locRes.json();
        if (!locData.success) return;

        const conflictData = await conflictRes.json();

        setBlockedLocations(conflictData.usedLocationIds);
        //setLocations(locData.locations);

        // 🚨 ONLY SOURCE OF TRUTH
        const waiverLocations = waiverData?.waiver?.locations || [];       
        const waiverLocationIds = new Set(
          waiverLocations.map(loc => loc._id)
        );  
        const filteredLocations = locData.locations.filter(loc => {
          const isArchivedLocation =
            loc.isDeleted || !loc.isActive;

          // always show active locations
          if (!isArchivedLocation) return true;

          // for archived locations:
          // only show if already attached to waiver
          return waiverLocationIds.has(loc._id);
        });

        setLocations(filteredLocations); /* filteredLocations Logic: (1) New/active waiver: 
                                          User sees: only active locations
                                          because backend already filtered archived ones.

                                          (2) Archived waiver
                                          Backend returns all locations. Frontend then shows:
                                          all active locations
                                          only archived locations linked to this waiver
                                          Perfect balance. */

                      
       

        if (waiverLocations.length > 0) {
          /*setSelected(waiverLocations);*/
          setSelected(
            waiverLocations.map(loc => loc._id)
          );
        } else if (newLocationId) {
          setSelected([newLocationId]);
        } else if (filteredLocations.length > 0) {
          //setSelected([locData.locations[0]._id]); - it sets blocked location as selected too
        } /* else if (!newLocationId && from !== "back") {
          navigate(`/business/waiverbuilder/smart/${waiverId}/step-2a`);
        }*/

      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, [business, waiverId, newLocationId, navigate]);


 const handleContinue = async () => {
    if (selected.length === 0) {
      alert("Please select at least one location");
      return;
    }

    if (saving) return;

    setSaving(true);

    try {
      const res = await fetch(
        `${API_URL.BUSINESS_WAIVER_SMART_STEP_SAVE_LOCATION}/${waiverId}`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${business.token}`,
            "x-session-id": business.sessionId,
            "x-frontend-url": window.location.pathname,
          },
          body: JSON.stringify({ locationIds: selected }),
        }
      );

      const data = await res.json();

      if (data.success) {
        navigate(`/business/waiverbuilder/smart/${waiverId}/step-3`);
      } else {
        alert(data.message);
      }
    } catch (err) {
      console.error("Failed to save locations", err);
    } finally {
      setSaving(false);
    }
  };

  //Checkbox handler - Make toggleLocation defensive: to guard against future mistakes
  const toggleLocation = (id) => {
    setSelected((prev) => {
      const safePrev = Array.isArray(prev) ? prev : [prev];

      return safePrev.includes(id)
        ? safePrev.filter((x) => x !== id)
        : [...safePrev, id];
    });
  };

  if (loading) return <div>Loading...</div>;

  if (locations.length === 0) {
    return (
      <>
      {/* <div className="h-screen flex bg-background">
        <Sidebar />

        <div className="flex-1 flex items-center justify-center"> */ }
        <WaiverStepLayout  waiver={waiver} currentStep="step-2" isReadOnly={isReadOnly} readOnlyReason={readOnlyReason} >
          <div className="w-full max-w-md text-center">

            <button
              onClick={() => navigate(`/business/waivers`)}
              className="text-sm text-muted-foreground mb-6"
            >
              ← Back to creation mode
            </button>

            <h1 className="text-2xl font-semibold mb-2">
              You need a location before this waiver can be published
            </h1>

            <p className="text-sm text-muted-foreground mb-8">
              Locations are where customers will sign this waiver.
            </p>

            <button
              onClick={() =>
                navigate(`/business/waiverbuilder/smart/${waiverId}/step-2a`)
              }
              className="w-full bg-yellow-500 rounded-full py-3 font-medium"
            >
              Create your first location →
            </button>

          </div>
        </WaiverStepLayout>
      {  /* </div>
      </div> */ }
      </>
    );
  }  

  return (
    <>
      {/* <div className="h-screen flex bg-background">
        <Sidebar />

        <div className="flex-1 flex items-center justify-center"> */ }
        <WaiverStepLayout  waiver={waiver} currentStep="step-2" isReadOnly={isReadOnly} readOnlyReason={readOnlyReason} >
          <div className="max-w-3xl mx-auto px-6">
          
            <div className="flex items-center justify-between mb-6">
            {isReadOnly ? (
              <button
                onClick={() =>
                  navigate(`/business/waiverbuilder/smart/${waiverId}/step-3`)
                }
                className="text-sm text-muted-foreground"
              >
                Next Step →
              </button>
            ) : (
              <button
                onClick={() =>
                  navigate(`/business/waivers`)
                }
                className="text-sm text-muted-foreground"
              >
                ← Back to creation mode
              </button>
            )}
            </div>
            
            <h1 className="text-2xl font-semibold mb-1">
              {isReadOnly ? "Waiver Locations (Read Only)" : "Choose Waiver Locations"}
            </h1>
            <p className="text-sm text-muted-foreground mb-8">
              Step 2 of 7 · Configure screening requirements
            </p>

            <div className="w-full border rounded-lg p-3 mb-4 max-h-64 overflow-y-auto text-left">
              {locations.map((loc) => (
                <label key={loc._id} className="flex flex-col gap-1 py-2 cursor-pointer">
                  <div className="flex items-center gap-3">
                    <input
                      type="checkbox"
                      disabled={isReadOnly || blockedLocations.includes(loc._id) || loc.isDeleted || !loc.isActive}
                      checked={selected.includes(loc._id)}
                      onChange={() => toggleLocation(loc._id)}
                      className="w-4 h-4"
                    />
                    <div>
                      <div className="font-medium">{loc.name}</div>
                      <div className="text-xs text-muted-foreground">{loc.street}</div>
                      <div className="text-xs text-muted-foreground">                        
                        {loc.city}, {loc.state}, {loc.zip} {(loc.isDeleted || !loc.isActive) && " (Archived)"}
                      </div>
                    </div>
                  </div>

                  {blockedLocations.includes(loc._id) && (
                    <div className="text-xs text-red-500 ml-7">
                      A published/draft waiver already exists for this service at this location
                    </div>
                  )}
                </label>
              ))}
            </div>

            {!isReadOnly && (
            <button
              onClick={handleContinue}
              disabled={selected.length === 0 || saving}
              className={`w-full rounded-full py-3 font-medium ${
                selected.length === 0 || saving
                  ? "bg-yellow-100 text-yellow-400 cursor-not-allowed"
                  : "bg-yellow-500 hover:bg-yellow-600 text-black"
              }`}
            >
              {saving ? "Saving..." : "Assign Locations →"}
            </button>
            )}

            {!isReadOnly && (
            <div className="mt-4">
              <button
                onClick={() =>
                  navigate(
                    `/business/waiverbuilder/smart/${waiverId}/step-2a`
                  )
                }
                className="text-sm underline"
              >
                Add new location
              </button>
            </div>
            )}

          </div>
        </WaiverStepLayout>
      {  /* </div>
      </div> */ }
      </>
  );
};

export default BusinessSmartTemplateStep2;